// extracted by mini-css-extract-plugin
export var locationCard = "_pg-0";